import { render } from "./BienvenidaPage.vue?vue&type=template&id=27409db0&scoped=true"
import script from "./BienvenidaPage.vue?vue&type=script&lang=js"
export * from "./BienvenidaPage.vue?vue&type=script&lang=js"

import "./BienvenidaPage.vue?vue&type=style&index=0&id=27409db0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27409db0"]])

export default __exports__